// eSign API — firm-side CRUD + portal-side sign flow.
// See /app/backend/routers/esign_router.py for the wire format.
import { API } from './_client';

export const esign = {
  list: (opts = {}) => API.get('/esign', { params: opts }).then((r) => r.data),
  get: (id) => API.get(`/esign/${id}`).then((r) => r.data),
  create: (payload) => API.post('/esign', payload).then((r) => r.data),
  bulkCreate: (payload) => API.post('/esign/bulk', payload).then((r) => r.data),
  uploadPdf: (fields) => {
    const fd = new FormData();
    Object.entries(fields).forEach(([k, v]) => { if (v !== null && v !== undefined) fd.append(k, v); });
    return API.post('/esign/upload-pdf', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
  remind: (id) => API.post(`/esign/${id}/remind`).then((r) => r.data),
  cancel: (id) => API.delete(`/esign/${id}`).then((r) => r.data),
  certificatePdf: (id) => API.get(`/esign/${id}/certificate.pdf`, { responseType: 'blob' }).then((r) => r.data),
  sourcePdfUrl: (id) => `${API.defaults.baseURL}/esign/${id}/source.pdf`,
  remindersScan: () => API.post('/esign/reminders/scan').then((r) => r.data),
  analytics: (days = 90) => API.get('/esign/analytics', { params: { days } }).then((r) => r.data),
  analyticsPdf: (days = 90) => API.get('/esign/analytics/pdf', { params: { days }, responseType: 'blob' }).then((r) => r.data),
  portal: {
    list: () => API.get('/portal/esign').then((r) => r.data),
    get: (id) => API.get(`/portal/esign/${id}`).then((r) => r.data),
    sign: (id, payload) => API.post(`/portal/esign/${id}/sign`, payload).then((r) => r.data),
    certificatePdf: (id) => API.get(`/portal/esign/${id}/certificate.pdf`, { responseType: 'blob' }).then((r) => r.data),
    sourcePdfUrl: (id) => `${API.defaults.baseURL}/portal/esign/${id}/source.pdf`,
    savedSignature: () => API.get('/portal/esign/signature-template').then((r) => r.data),
    deleteSavedSignature: () => API.delete('/portal/esign/signature-template').then((r) => r.data),
  },
};
